/** The backend's limit on a booking's notes (`specialRequests`, `@Size(max = 2000)`). */
export const SPECIAL_REQUESTS_MAX_LENGTH = 2000

/**
 * The notes sent with a booking: each present part on its own line, cut to what the server
 * accepts so a completed form is never rejected for its length. The customer's own text comes
 * last, so any cut falls there rather than on the tyre or vehicle details the garage relies on.
 */
export function joinBookingNotes(parts: ReadonlyArray<string | null | undefined>): string | null {
  const notes = parts.filter((part): part is string => Boolean(part)).join('\n')
  return notes ? notes.slice(0, SPECIAL_REQUESTS_MAX_LENGTH) : null
}
